<!-- Error Views -->
<app-module-error *ngIf="noData" [noData]="true"></app-module-error>  
<!-- Content -->
<div class="gridItemChildModule h-100 d-flex flex-column" *ngIf="dataLoadSuccess && !noData">

    <!-- Search -->
    <div *ngIf="!configService.isCxOne" class="search-box live-search w-75 mx-auto my-2" [hidden]="!showFilter">
        <input type="search" class="form-control"
            autocomplete="off"
            [(ngModel)]="filterValue"
            (ngModelChangeDebounced)="applyFilter()"
            [ngModelChangeDebounceTime]="500"
            ng-trim="true"
            placeholder="Search"
            cvLocalizedPlaceholder
            [langSection]="'Common'"
            [langKey]="'Search'"
        />
        <span class="clear-input" role="button" tabindex="0" [hidden]="!(filterValue.length > 0)" (click)="clearFilter()"></span>
    </div>

    <!-- Search cxone -->
    <div *ngIf="configService.isCxOne" class="cxone-live-search ml-2 my-2" [hidden]="!showFilter">
        <sol-text-input [(ngModel)]="filterValue" [placeholder]="searchPlaceholder" (keyup)="applyFilter()" class="cxone-widget-search"
            (ngModelChangeDebounced)="filterValue" [ngModelChangeDebounceTime]="500"
            name="cxoneInput-{{moduleKey}}"></sol-text-input>
        <i class="cxone-search-icon" [hidden]="filterValue.length !== 0">
            <svg class="icon-18 fill-iconDefault cxone-search-wrapper">
                <use href="../App_Themes/CXone/icons/search.svg#search"></use>
            </svg>
        </i>
        <i [hidden]="filterValue.length === 0" (click)="clearFilter()">
            <svg class="icon-18 fill-iconDefault-noHover cxone-close-wrapper">
                <use href="../App_Themes/CXone/icons/close.svg#close"></use>
            </svg>
        </i>
    </div>

    <ag-grid-angular
        #leaderboardWidgetGrid 
        *ngIf="gridOptions !== null" 
        [hidden]="!configService.isCxOne && !isGridReady"
        class="ag-theme-balham flex-fill leaderboard-container" 
        [gridOptions]="gridOptions"
        style="overflow: auto;">
    </ag-grid-angular>
</div>
